import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import CRUDFurnisher from "../CRUD/CRUDFurnisher";
import { FurnisherDto } from "../../api-clients/api";
import { useTranslation } from "react-i18next";

export default function NewFurnisher() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader title={t("furnishers.createTitle")} />
      <CardContent>
        <CRUDFurnisher furnisher={{} as FurnisherDto} />
      </CardContent>
    </Card>
  );
}
